// extracted by mini-css-extract-plugin
module.exports = {"aboutText":"About-module--aboutText--IiOFt"};